import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import VersiBaru from "@/components/VersiBaru";
import ZonaWaktu from "@/components/ZonaWaktu";
import { AuthProvider } from "@/context/AuthContext";
import { UnggahanProvider } from "@/context/UnggahanContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import UserManagement from "@/pages/UserManagement";
import BarangManagement from "@/pages/BarangManagement";
import BahanManagement from "@/pages/BahanManagement";
import SupplierManagement from "@/pages/SupplierManagement";
import StatusOrder from "@/pages/StatusOrder";
import TransaksiDigitalPrint from "@/pages/TransaksiDigitalPrint";
import TransaksiCustom from "@/pages/TransaksiCustom";
import NotaDigital from "@/pages/NotaDigital";
import InvoicePublik from "@/pages/InvoicePublik";
import HalamanCustomer from "@/pages/HalamanCustomer";
import AccCustomer from "@/pages/AccCustomer";
import AccMockup from "@/pages/AccMockup";
import CetakSpk from "@/pages/CetakSpk";
import TransaksiJersey from "@/pages/TransaksiJersey";
import JerseyOrderMasuk from "@/pages/JerseyOrderMasuk";
import JerseyDetail from "@/pages/JerseyDetail";
import JerseyNama from "@/pages/JerseyNama";
import JerseySiapDesain from "@/pages/JerseySiapDesain";
import SiapDiambil from "@/pages/SiapDiambil";
import LaporanPage from "@/pages/LaporanPage";
import PengaturanPage from "@/pages/PengaturanPage";
import PembayaranPage from "@/pages/PembayaranPage";
import BukuKas from "@/pages/BukuKas";
import CetakKas from "@/pages/CetakKas";
import StokPage from "@/pages/StokPage";
import KartuStok from "@/pages/KartuStok";
import PembelianPage from "@/pages/PembelianPage";
import CetakNota from "@/pages/CetakNota";
import CetakInvoice from "@/pages/CetakInvoice";
import TarifManagement from "@/pages/TarifManagement";
import PosProduksiManagement from "@/pages/PosProduksiManagement";
import WorkflowManagement from "@/pages/WorkflowManagement";
import CustomerManagement from "@/pages/CustomerManagement";
import OrderManagement from "@/pages/OrderManagement";
import SpkManagement from "@/pages/SpkManagement";
import NotaManagement from "@/pages/NotaManagement";
import ProductionQueue from "@/pages/ProductionQueue";
import ProductionMonitoring from "@/pages/ProductionMonitoring";
import PublicTracking from "@/pages/PublicTracking";
import TvDisplay from "@/pages/TvDisplay";
import LayarProduksi from "@/pages/LayarProduksi";
import LayarUji from "@/pages/LayarUji";
import AntreanLabel from "@/pages/AntreanLabel";
import UjiLabel from "@/pages/UjiLabel";
import AturLayarProduksi from "@/pages/AturLayarProduksi";
import RiwayatProduksi from "@/pages/RiwayatProduksi";
import FormPosPage from "@/pages/FormPosPage";
import BoronganPage from "@/pages/BoronganPage";
import WhatsappPage from "@/pages/WhatsappPage";
import PriceList from "@/pages/PriceList";
import HariLibur from "@/pages/HariLibur";
import GantiPassword from "@/pages/GantiPassword";
import { PENGAWAS, PRODUCTION_ROLES } from "@/lib/roles";
import SpkBatalPage from "@/pages/SpkBatalPage";
import RiwayatPembayaran from "@/pages/RiwayatPembayaran";
import MasukanCustomer from "@/pages/MasukanCustomer";
import Bantuan from "@/pages/Bantuan";
import CatatanPembaruan from "@/pages/CatatanPembaruan";

function App() {
  return (
    <div className="App">
      <ZonaWaktu>
      <AuthProvider>
        <BrowserRouter>
          {/* v2.22.2: the file master upload queue lives above the pages (keeps running when the menu changes) */}
          <UnggahanProvider>
          <VersiBaru />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/tracking/:token" element={<PublicTracking />} />
            <Route path="/n/:token" element={<NotaDigital />} />
            <Route path="/n/:token/invoice" element={<InvoicePublik />} />
            <Route path="/c/:token" element={<HalamanCustomer />} />
            <Route path="/acc/:token" element={<AccCustomer />} />
            <Route path="/acc-mockup" element={<ProtectedRoute roles={["admin", "kasir", "desain", "manager"]}><AccMockup /></ProtectedRoute>} />
            <Route path="/tv" element={<TvDisplay />} />
            <Route path="/monitoring/layar" element={<LayarProduksi />} />
            <Route path="/monitoring/layar/uji" element={<LayarUji />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/ganti-password" element={<ProtectedRoute><GantiPassword /></ProtectedRoute>} />
            <Route path="/hari-libur" element={<ProtectedRoute roles={["admin", "finance"]}><HariLibur /></ProtectedRoute>} />
            {/* owner 2026-10-11/12: the summary is part of the dashboard; old links / installed app keep working */}
            <Route path="/ringkasan" element={<ProtectedRoute adminOnly><Navigate to="/" replace /></ProtectedRoute>} />
            <Route path="/production-monitoring" element={<ProtectedRoute roles={PENGAWAS}><ProductionMonitoring /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute roles={PENGAWAS}><UserManagement /></ProtectedRoute>} />
            <Route path="/tarif" element={<ProtectedRoute adminOnly><TarifManagement /></ProtectedRoute>} />
            <Route path="/barang" element={<ProtectedRoute roles={PENGAWAS}><BarangManagement /></ProtectedRoute>} />
            <Route path="/bahan" element={<ProtectedRoute roles={["admin", "finance", "manager"]}><BahanManagement /></ProtectedRoute>} />
            <Route path="/supplier" element={<ProtectedRoute roles={["admin", "finance"]}><SupplierManagement /></ProtectedRoute>} />
            <Route path="/pos-produksi" element={<ProtectedRoute roles={PENGAWAS}><PosProduksiManagement /></ProtectedRoute>} />
            <Route path="/workflow" element={<ProtectedRoute roles={PENGAWAS}><WorkflowManagement /></ProtectedRoute>} />
            <Route path="/customers" element={<ProtectedRoute roles={["admin", "kasir", "desain"]}><CustomerManagement /></ProtectedRoute>} />
            <Route path="/transaksi-dp" element={<ProtectedRoute roles={["admin", "kasir"]}><TransaksiDigitalPrint /></ProtectedRoute>} />
            <Route path="/transaksi-dtf" element={<ProtectedRoute roles={["admin", "kasir"]}><TransaksiDigitalPrint key="dtf" jenis="DTF" /></ProtectedRoute>} />
            <Route path="/transaksi-custom" element={<ProtectedRoute roles={["admin", "kasir"]}><TransaksiCustom /></ProtectedRoute>} />
            <Route path="/jersey" element={<ProtectedRoute roles={["admin", "kasir"]}><JerseyOrderMasuk /></ProtectedRoute>} />
            <Route path="/jersey/baru" element={<ProtectedRoute roles={["admin", "kasir"]}><TransaksiJersey /></ProtectedRoute>} />
            <Route path="/jersey/desain" element={<ProtectedRoute roles={["admin", "desain"]}><JerseySiapDesain /></ProtectedRoute>} />
            <Route path="/jersey/:id" element={<ProtectedRoute roles={["admin", "kasir"]}><JerseyDetail /></ProtectedRoute>} />
            <Route path="/jersey/:id/ubah" element={<ProtectedRoute roles={["admin", "kasir"]}><TransaksiJersey /></ProtectedRoute>} />
            <Route path="/jersey/:id/nama" element={<ProtectedRoute roles={["admin", "kasir"]}><JerseyNama /></ProtectedRoute>} />
            <Route path="/siap-diambil" element={<ProtectedRoute roles={["admin", "kasir"]}><SiapDiambil /></ProtectedRoute>} />
            <Route path="/laporan" element={<ProtectedRoute roles={["admin", "kasir", "finance"]}><LaporanPage /></ProtectedRoute>} />
            <Route path="/spk/:id/cetak" element={<ProtectedRoute roles={["admin", "kasir"]}><CetakSpk /></ProtectedRoute>} />
            <Route path="/pembayaran" element={<ProtectedRoute roles={["admin", "kasir"]}><PembayaranPage /></ProtectedRoute>} />
            <Route path="/price-list" element={<ProtectedRoute roles={["admin", "kasir", "finance"]}><PriceList /></ProtectedRoute>} />
            <Route path="/kas" element={<ProtectedRoute roles={["admin", "finance"]}><BukuKas /></ProtectedRoute>} />
            <Route path="/kas/cetak" element={<ProtectedRoute roles={["admin", "finance"]}><CetakKas /></ProtectedRoute>} />
            <Route path="/stok" element={<ProtectedRoute roles={["admin", "kasir", "finance", "manager"]}><StokPage /></ProtectedRoute>} />
            <Route path="/stok/:id/kartu" element={<ProtectedRoute roles={["admin", "kasir", "finance", "manager"]}><KartuStok /></ProtectedRoute>} />
            <Route path="/pembelian" element={<ProtectedRoute roles={["admin", "finance"]}><PembelianPage /></ProtectedRoute>} />
            <Route path="/nota/:id/cetak" element={<ProtectedRoute roles={["admin", "kasir"]}><CetakNota /></ProtectedRoute>} />
            <Route path="/nota/:id/invoice" element={<ProtectedRoute roles={["admin", "kasir", "finance"]}><CetakInvoice /></ProtectedRoute>} />
            <Route path="/riwayat-produksi" element={<ProtectedRoute roles={["admin", "kasir", "desain", "manager"]}><RiwayatProduksi /></ProtectedRoute>} />
            <Route path="/borongan" element={<ProtectedRoute><BoronganPage /></ProtectedRoute>} />
            <Route path="/whatsapp" element={<ProtectedRoute adminOnly><WhatsappPage /></ProtectedRoute>} />
            <Route path="/form-pos" element={<ProtectedRoute roles={PENGAWAS}><FormPosPage /></ProtectedRoute>} />
            <Route path="/pengaturan" element={<ProtectedRoute adminOnly><PengaturanPage /></ProtectedRoute>} />
            <Route path="/status-order" element={<ProtectedRoute roles={["admin", "kasir", "desain", "manager"]}><StatusOrder /></ProtectedRoute>} />
            <Route path="/orders" element={<ProtectedRoute roles={["admin", "kasir"]}><OrderManagement /></ProtectedRoute>} />
            {/* owner 2026-10-15 (A6): every role may look at every SPK (server strips money / contacts / names per role) */}
            <Route path="/spk" element={<ProtectedRoute><SpkManagement /></ProtectedRoute>} />
            <Route path="/riwayat-pembayaran" element={<ProtectedRoute roles={["admin", "finance", "kasir"]}><RiwayatPembayaran /></ProtectedRoute>} />
            <Route path="/bantuan" element={<ProtectedRoute><Bantuan /></ProtectedRoute>} />
            {/* owner 2026-10-17 (VERSI-APLIKASI): release notes in plain words, every role */}
            <Route path="/catatan-pembaruan" element={<ProtectedRoute><CatatanPembaruan /></ProtectedRoute>} />
            <Route path="/masukan-customer" element={<ProtectedRoute roles={["admin", "manager"]}><MasukanCustomer /></ProtectedRoute>} />
            <Route path="/label" element={<ProtectedRoute roles={["admin", "qc"]}><AntreanLabel /></ProtectedRoute>} />
            <Route path="/label/uji" element={<ProtectedRoute roles={["admin", "qc"]}><UjiLabel /></ProtectedRoute>} />
            <Route path="/production-monitoring/layar" element={<ProtectedRoute roles={["admin", "manager", "finance"]}><AturLayarProduksi /></ProtectedRoute>} />
            <Route path="/spk-batal" element={<ProtectedRoute roles={PENGAWAS}><SpkBatalPage /></ProtectedRoute>} />
            <Route path="/nota" element={<ProtectedRoute roles={["admin", "kasir"]}><NotaManagement /></ProtectedRoute>} />
            <Route path="/production" element={<ProtectedRoute roles={PRODUCTION_ROLES}><ProductionQueue /></ProtectedRoute>} />
          </Routes>
          </UnggahanProvider>
        </BrowserRouter>
      </AuthProvider>
      </ZonaWaktu>
    </div>
  );
}

export default App;
